var _path, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 183,
    viewBox: "0 0 100 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9418 153.48H1.95723V129.426L34.8711 96.0914C41.6808 88.8941 46.9774 83.1496 50.7608 78.8568C54.6708 74.564 57.3818 70.9026 58.8949 67.8714C60.4081 64.8413 61.1652 61.6845 61.1652 58.4021C61.1652 54.3616 59.8408 51.4583 57.1931 49.6898C54.6708 47.9224 51.6445 47.0388 48.1131 47.0388C43.8257 47.0388 39.5383 48.2381 35.2497 50.6368C30.9623 53.0356 26.0443 56.6348 20.4958 61.4322L0.444092 37.9474C4.47951 34.286 8.76692 30.8135 13.3075 27.5311C17.9735 24.2487 23.3966 21.5965 29.5757 19.5769C35.7537 17.4305 43.3205 16.3567 52.2739 16.3567C61.2274 16.3567 69.4248 17.9985 76.1079 21.2808C82.7922 24.4377 87.9621 28.7938 91.619 34.3493C95.4024 39.9049 97.2941 46.2185 97.2941 53.289C97.2941 59.0968 96.4748 64.4634 94.8351 69.3876C93.322 74.1862 90.9263 78.8568 87.6469 83.4031C84.494 87.9482 80.4586 92.6834 75.5406 97.6076C70.7492 102.406 65.1374 107.709 58.7051 113.517L48.8691 122.418V123.366H99.9418V153.48Z",
    fill: "#A6FA04"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 66.4973,
    cy: 91.607,
    rx: 28.4279,
    ry: 91.1366,
    fill: "url(#paint0_radial_526_1716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_526_1716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.4973 91.607) rotate(90) scale(91.1366 28.4279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090A14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090A14",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoVector);
export default __webpack_public_path__ + "static/media/two-vector.d37ffc7bfa01d70dafffd774a63e7dc2.svg";
export { ForwardRef as ReactComponent };